module.exports = __webpack_public_path__ + "static/img/action-icon1.eabebcb5.png";